import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

import InplayIcon from "../assets/images/games-icon/live.png";
import CricketIcon from "../assets/images/games-icon/throw.png";
import SoccerIcon from "../assets/images/games-icon/soccer-ball-variant.png";
import TennisIcon from "../assets/images/games-icon/tennis.png";
import horseracingIcon from "../assets/images/games-icon/horse.png";
import BasketballIcon from "../assets/images/games-icon/basketball.png";
import WalletIcon from "../assets/images/WalletIcon.png";
import UserIcon from "../assets/images/user-icon.svg";
import BetIcon from "../assets/images/money-bag.webp";
import AcStatement from "../assets/images/financial-document.webp";
import LogoutIconImg from "../assets/images/logout.webp";
import BonusImg from "../assets/images/gift.webp";
import refferal from "../assets/images/refer.webp";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import KycIcon from "../assets/images/kyc.png";
import { logoutUser } from "../redux/auth/actions";

const MobLeftbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sportsData } = useSelector((state) => state.sports);
  const { isAuth } = useSelector((state) => state.auth);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`,
    );
  };

  const { user, balance, wallet } = useSelector((state) => state.auth);

  const [isClassAdded, setIsClassAdded] = useState(false);
  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
  }, []);
  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  return (
    <div className="mobleftbarPage">
      <div className="leftbarSec">
        {isAuth && (
          <>
            <div className="d-flex profilemobsection">
              <div className="profile-img">
                <img src={UserIcon} alt="User Icon" />
              </div>
              <div className="user-info">
                <Link className="user_name" to="/profile">
                  {user?.mstruserid}
                </Link>
                <p>{user?.mobileno}</p>
              </div>
            </div>
            <div className="container upperbalnace">
              <div className="d-flex align-items-center justify-content-between  mb-3">
                <div className="balance">
                  <img src={WalletIcon} alt="wallet" />
                  Balance
                </div>
                <div className="balance-amount">{wallet?.balance}</div>
              </div>

              <div className="row">
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/withdraw");
                  }}>
                  <Button variant="" className="btn_withdraw w-100">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/gatewaylist");
                  }}>
                  <Button variant="primary" className="btn_primary w-100">
                    Deposit
                  </Button>
                </div>

                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/bonus");
                  }}>
                  <Button variant="" className="btn_withdraw mt-2 w-100">
                    Bonus
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/mybets");
                  }}>
                  <Button variant="" className="btn_withdraw  mt-2 w-100">
                    My Bets
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
        <ul>
          <li className="games_link">
            <ul>
              <li>
                <div
                  onClick={() => {
                    navigate("/");
                  }}>
                  <img src={InplayIcon} alt="Inplay" />
                  <span>Popular Games</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Inplay");
                  }}>
                  <img src={InplayIcon} alt="Inplay" />
                  <span>Live</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/promotions");
                  }}>
                  <img src={CricketIcon} alt="Cricket" />
                  <span>Promotions</span>
                </div>
              </li>
              {/* <li>
                <div
                  onClick={() => {
                    navigate("/sports/AGSE");
                  }}
                >
                  <img src={TennisIcon} alt="" />
                  <span>New Exchange</span>
                </div>
              </li> */}
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Cricket");
                  }}>
                  <img src={TennisIcon} alt="" />
                  <span>Cricket</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Soccer");
                  }}>
                  <img src={TennisIcon} alt="" />
                  <span>Football</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Basketball");
                  }}>
                  <img src={BasketballIcon} alt="Basketball" />
                  <span>Basketball</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Tennis");
                  }}>
                  <img src={TennisIcon} alt="" />
                  <span>Tennis</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/TableTennis");
                  }}>
                  <img src={TennisIcon} alt="" />
                  <span>Table Tennis</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Horse%20Racing");
                  }}>
                  <img src={horseracingIcon} alt="horseracing" />
                  <span>Horseracing</span>
                </div>
              </li>
            </ul>
          </li>

          {isAuth && (
            <li className="games_link">
              <h6>My Account</h6>
              <ul className="account-menu">
                <li>
                  <div>
                    <a href="/mybets">
                      <img src={BetIcon} alt="my bet" />
                      <span>My Bets</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a href="/bonus" className="img_size">
                      <img src={BonusImg} />
                      <span className="bonus-space">Bonus</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a href="/referral" className="img_size">
                      <img src={refferal} />
                      <span className="bonus-space">Referral</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a href="/cashier">
                      <img src={AcStatement} alt="account statement" />
                      <span>Account Statement</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a href="/kyc">
                      <img src={KycIcon} alt="kyc" />
                      <span>KYC</span>
                    </a>
                  </div>
                </li>
                <li onClick={() => dispatch(logoutUser())}>
                  <div>
                    <a href="/">
                      {/* <LogoutIcon /> */}
                      <img src={LogoutIconImg} />
                      <span>Sign Out</span>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="theme-btn">
                    <buton type="button" className="btn" onClick={toggleClass}>
                      <img src={SunLight} alt="sun" className="light_theme" />
                      <img src={MoonLight} alt="moon" className="dark_theme" />
                    </buton>
                  </div>
                </li>
              </ul>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MobLeftbar;
